import { render, staticRenderFns } from "./CopyRuleDialog.vue?vue&type=template&id=30f252c1&scoped=true"
import script from "./CopyRuleDialog.vue?vue&type=script&lang=ts"
export * from "./CopyRuleDialog.vue?vue&type=script&lang=ts"
import style0 from "./CopyRuleDialog.vue?vue&type=style&index=0&id=30f252c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f252c1",
  null
  
)

export default component.exports